import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from './types'

export const customFetchBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_PATIENT_API_URL,
  prepareHeaders: async (headers, { getState }) => {
    headers.set('Content-Type', 'application/json')

    const state = getState() as RootState
    const apiToken = state?.appConfig?.apiToken

    if (apiToken) {
      headers.set('api-token', apiToken)
    }
    return headers
  },
})
